import axios from 'axios'
import { checkRequestRate } from '../utils/antiScrape'

const api = axios.create({
  baseURL: '/api',
  timeout: 10000
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 检查请求频率
    if (!checkRequestRate(30, 60000)) { // 每分钟最多30次请求
      return Promise.reject(new Error('请求过于频繁，请稍后再试'))
    }

    // 添加认证 token
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    // 添加防爬相关的请求头
    config.headers['Accept'] = config.headers['Accept'] || 'application/json, text/plain, */*'
    config.headers['Accept-Language'] = navigator.language || 'zh-CN,zh;q=0.9,en;q=0.8'
    
    // 确保有 Referer（浏览器会自动添加，但明确设置更安全）
    if (!config.headers['Referer'] && typeof window !== 'undefined') {
      config.headers['Referer'] = window.location.origin
    }

    // 添加 Origin（浏览器会自动添加，但明确设置更安全）
    if (!config.headers['Origin'] && typeof window !== 'undefined') {
      config.headers['Origin'] = window.location.origin
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => response.data,
  error => {
    // 处理 401 未授权
    if (error.response?.status === 401) {
      // 如果当前就是登录页，只把错误抛给调用方，让页面自己做 toast 提示
      if (typeof window !== 'undefined' && window.location.pathname === '/login') {
        return Promise.reject(error)
      }

      // 其它页面遇到 401：清理本地登录状态并跳转到登录页
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      window.location.href = '/login'
      return Promise.reject(error)
    }
    // 处理 429 请求过于频繁
    else if (error.response?.status === 429) {
      console.warn('[AntiScrape] 请求过于频繁，已被限流')
      // 可以在这里显示提示信息
    }
    // 处理 403 请求被拒绝（可能是防爬拦截）
    else if (error.response?.status === 403) {
      console.warn('[AntiScrape] 请求被拒绝，可能是防爬保护')
    }
    return Promise.reject(error)
  }
)

export default api
